export default __webpack_public_path__ + "static/media/check-4.5c683057.svg";